import { letsgotheme } from '@jotta/ui/themes/letsgo'
import { startApp } from '../App'

startApp(letsgotheme)
